import { Flex, Text } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { useProjectsPageSearchQueryStates } from '@/features/project/_hooks/search-projects/search-query-states';
import { useId } from '@/hooks';
import { t } from '@/i18n';
import type { FC } from 'react';
import { useGroupProjects } from '../../_hooks/group';
import { GroupInProjectsBulkActionsButton } from './GroupInProjectsBulkActionsButton';
import { GroupInProjectsSummary } from './GroupInProjectsSummary';
import { GroupInProjectsTable } from './GroupInProjectsTable';

type Props = {
  editPermission: boolean;
};

export const GroupInProjects: FC<Props> = ({ editPermission }) => {
  const { id } = useId();
  const { searchQueryStates } = useProjectsPageSearchQueryStates();

  const groupProjects = useGroupProjects({
    id,
    page: searchQueryStates.groupInProjectsPage,
    ordering: searchQueryStates.groupInProjectsOrdering,
  });
  return (
    <Flex vertical gap={16}>
      <GroupInProjectsSummary />
      <Flex align="center" gap={8}>
        <Text
          text={t('number-of-project-in-project-group', {
            number: groupProjects.data?.count ?? 0,
          })}
        />
        <ProjectResourceGuard onlyEdit>
          <GroupInProjectsBulkActionsButton />
        </ProjectResourceGuard>
      </Flex>
      <GroupInProjectsTable
        groupInProjects={groupProjects.data}
        isLoading={groupProjects.isLoading}
        editPermission={editPermission}
      />
    </Flex>
  );
};
